export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_uk.0aa615d9445f9660.json"